import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { relativeTime } from '@platform/core/lib/format';
import { useAppSelector } from '@platform/state/hooks';
import { selectLang } from '@platform/state/selectors';
import type { IInvitationRowProps } from './IInvitationRowProps';

/** Скільки показувати «Надіслано ✓» після повторного надсилання (прототип v4: 1,6 с). */
const RESENT_MS = 1600;

/**
 * Рядок запрошення, що очікує (прототип v4 G:L2790): «@» у пунктирному колі 34px, адреса 600, «роль · запросив(-ла) хто коли»,
 * «Надіслати повторно» (після успіху — «Надіслано ✓» на 1,6 с) і «Відкликати» кольором небезпеки.
 */
export function InvitationRow({ invitation, onResend, onRevoke }: IInvitationRowProps) {
  const { t } = useTranslation();
  const lang = useAppSelector(selectLang);
  const [resent, setResent] = useState(false);
  useEffect(() => {
    if (!resent) return undefined;
    const timer = window.setTimeout(() => setResent(false), RESENT_MS);
    return () => window.clearTimeout(timer);
  }, [resent]);
  const role = t(`membersPage.roleNames.${invitation.role}`, { defaultValue: invitation.role });
  const when = relativeTime(invitation.sentAt, lang);
  const meta = invitation.invitedBy?.name ? t('membersPage.sentMetaBy', { role, when, who: invitation.invitedBy.name }) : t('membersPage.sentMeta', { role, when });
  return (
    <div className="mb-row">
      <span className="mb-avatar mb-avatar--invite" aria-hidden="true">@</span>
      <div className="mb-who">
        <span className="mb-name">{invitation.email}</span>
        <span className="mb-email">{meta}</span>
      </div>
      <button type="button" className="mb-resend" disabled={resent} onClick={() => void onResend(invitation.id).then((ok) => setResent(ok))}>
        {resent ? t('membersPage.resent') : t('membersPage.resend')}
      </button>
      <button type="button" className="mb-remove" onClick={() => onRevoke(invitation.id)}>{t('membersPage.revoke')}</button>
    </div>
  );
}
